import Api from '@/services/Api'

export default {
  show (params) {
    return Api().post('deviceWifi', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/DeviceWifiService.js